import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SiteAction } from '../../actions/SiteAction';
import { RayForm } from '../../components/common';
import { EditSaveCancelBar } from '../common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';
import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { useTranslation } from 'react-i18next';

const CUSTOMER_FIELDS = ['customerFirstName', 'customerLastName', 'customerHp', 'customerEmail'];
const toDraft = (s) => CUSTOMER_FIELDS.reduce((o, k) => ({ ...o, [k]: s?.[k] }), {});

const SiteCustomerInfo = ({ siteId, siteReducer, GetSite, UpdateSiteInfo, editable, siteInfo, cancelcallback = null }) => {
	const [t] = useTranslation();
	const site = siteReducer?._id ? siteReducer : siteInfo;
	const { draft, editing, saving, errors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
		source: site,
		toDraft,
		save: (changed) => UpdateSiteInfo(site._id, changed),
		editable: !!editable,
		entry: 'header',
		onClose: cancelcallback
	});

	useEffect(() => {
		if (siteId)
			GetSite(siteId);
	}, []);

	const canEditFields = editing;

	const form_controls = [
		{
			title: "", items: [
				{
					type: "input",
					name: "customerFirstName",
					label: t('common.field.firstName'),
					val: draft.customerFirstName,
					isEditable: canEditFields, size: 12
				},
			]
		},
		{
			title: "", items: [
				{
					type: "input",
					name: "customerLastName",
					label: t('common.field.lastName'),
					val: draft.customerLastName,
					isEditable: canEditFields, size: 12
				},
			]
		},
		{
			title: "", items: [
				{
					type: "input",
					name: "customerHp",
					label: t('common.field.mobile'),
					val: draft.customerHp,
					isEditable: canEditFields, size: 12
				},
			]
		},
		{
			title: "", items: [
				{
					type: "email",
					name: "customerEmail",
					label: t('common.field.email'),
					val: draft.customerEmail,
					isEditable: canEditFields, size: 12
				},
			]
		},
	]

	return (
		<>
			<RayForm
				controls={form_controls}
				handleChangeData={onChange}
				errors={errors} />
			<div className="ps-1 pe-1 mb-1">
				<EditSaveCancelBar canEdit={!!editable} editing={editing} onEdit={onEdit} onSave={() => onSave(form_controls)} onCancel={onCancel} saving={saving} />
			</div>
		</>
	);
};

const mapState = (state) => {
	const siteReducer = state.SiteReducer.site;
	return { siteReducer };
}

const mapDispatch = dispatch => ({
	UpdateSiteInfo: (_id, data) => dispatch(SiteAction.UpdateSiteInfo(_id, data)),
	GetSite: (_id) => dispatch(SiteAction.GetSite(_id))
})

export default connect(mapState, mapDispatch)(SiteCustomerInfo);